import axiosInstance from "../../utils/axiosInstance";

const eventGalleryService = {

    getPhotos: async (eventId) => {

        const response = await axiosInstance.get(
            `/Event/${eventId}/photos`
        );

        return response.data;
    },


   addPhoto: async (eventId, data) => {

    const response = await axiosInstance.post(
        `/Event/${eventId}/photos`,
        data
    );

    return response.data;
},

    updatePhoto: async (photoId, data) => {

        const response = await axiosInstance.put(
            `/Event/photos/${photoId}`,
            data
        );

        return response.data;
    },


    deletePhoto: async (photoId) => {

        const response = await axiosInstance.delete(
            `/Event/photos/${photoId}`
        );

        return response.data;
    }

};

export default eventGalleryService;